import { BaseModel, RecursivePartial } from "../base";

export class VzParamOldStyles extends BaseModel {
    prefix?: string;
    suffix?: string;
    subtype?: any;
    size?: any;
    checkedSymbol?: string;
    uncheckedSymbol?: string;
    hidden?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    maxWidth?: number | string;
    minWidth?: number | string;
    textAlign?: string;
    nzType?: string;
    loading?: boolean;
    vzType?: string;
    icon?: string;
    placeholder?: string;
    margin?: number | string;
    nomobile?: boolean;
    layout?: 'horizontal' | 'vertical';
    flex?: boolean;
    showCopyButton?: boolean;
    generateUniqueIds?: boolean;
    enumNames?: string[];
    sysModules?: string[][];
    draggable?: boolean;

    constructor(json?: RecursivePartial<VzParamOldStyles>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<VzParamOldStyles>): VzParamOldStyles {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<VzParamOldStyles>): void {
        VzParamOldStyles.assignFields<VzParamOldStyles>(this, json, [
            'prefix',
            'suffix',
            'subtype',
            'size',
            'checkedSymbol',
            'uncheckedSymbol',
            'hidden',
            'disabled',
            'readonly',
            'maxWidth',
            'minWidth',
            'textAlign',
            'nzType',
            'loading',
            'vzType',
            'icon',
            'placeholder',
            'margin',
            'nomobile',
            'layout',
            'flex',
            'showCopyButton',
            'generateUniqueIds',
            'enumNames',
            'sysModules',
            'draggable'
        ]);
        if (this.enumNames && !Array.isArray(this.enumNames)) {
            this.enumNames = undefined;
        }
    }
}
